<div class="custom-slider-wrapper">
  <div class="custom-slider">
    <!-- اسلایدر اصلی -->
    <div class="slides" [style.transform]="'translateX(' + slidePosition + '%)'">
      <div class="slide" *ngFor="let image of images; let i = index">
        <div class="image-container">
          <!-- اضافه کردن کلاس slider-image و استفاده از متد مناسب -->
          <img [src]="'https://cdick.ir/' + image.imageUrl" [alt]="image.title"
               class="slider-image"
               (click)="openImageFromSlider('https://cdick.ir/' + image.imageUrl)" />
               <!-- نکته: URL کامل را پاس می‌دهیم -->
        </div>
        <div class="caption">{{ image.title }}</div>
      </div>
    </div>
    <button class="nav prev" (click)="previousSlide()">❮</button>
    <button class="nav next" (click)="nextSlide()">❯</button>
  </div>

  <!-- لایت‌باکس -->
  <div class="lightbox" *ngIf="selectedImage" (click)="closeImage()">
    <!-- عکس لایت‌باکس مستقیماً از selectedImage می‌آید -->
    <img [src]="selectedImage" class="full-image" />
  </div>
</div>

<!-- بخش گالری تصاویر بندانگشتی -->
<!-- <div class="gallery-container">
  <div class="gallery-slider-wrapper">
    <div class="gallery-slides">

      <div class="gallery-slide" *ngFor="let image of images; let i = index">
        <div class="image-container thumbnail-container">

          <img [src]="'https://cdick.ir/' + image.imageUrl" [alt]="image.title"
               class="thumbnail"
               (click)="selectThumbnail('https://cdick.ir/' + image.imageUrl)" />

        </div>
      </div>
    </div>

  </div>
</div> -->


<!--
<div class="custom-slider">
  <div class="slides" [style.transform]="'translateX(' + slidePosition + '%)'">
    <div class="slide" *ngFor="let image of images; let i = index">


      <img [src]="'https://cdick.ir' + image.imageUrl" [alt]="image.title"
      (click)="openImage('https://cdick.ir' + image.imageUrl)"  />

      <div class="caption">{{ image.title }}</div>
    </div>


    <div class="lightbox" *ngIf="selectedImage" (click)="closeImage()">
    <img [src]="selectedImage" class="full-image" />
    </div>

  </div>
  <button class="nav prev" (click)="previousSlide()">❮</button>
  <button class="nav next" (click)="nextSlide()">❯</button>
</div>

<div class="gallery-container">
  <div class="image-slider">
    <img *ngFor="let img of images" [src]="img" (click)="openImage(img)" class="thumbnail" />
  </div>


  <div class="lightbox" *ngIf="selectedImage" (click)="closeImage()">
    <img [src]="selectedImage" class="full-image" />
  </div>
</div> -->



